<script>
	import Header from './components/Header.svelte'
	import Footer from './components/Footer.svelte'
	import Form from './components/Form.svelte'
	import Contact from './components/Contact.svelte';
</script>

<main class="text-white bg-slate-800 py-8">
	<Header />
	<Form />
	<Contact />
	<Footer />
</main>

<style>
	
</style>